import axios from 'axios';
import {
    Toast
} from 'vant';
import router from '../src/router'
import Config from '../config/index.js'
import Mui from '../src/assets/js/mui.js'
import {
    PresentType
} from '../config/index.js'

//环境的切换
if (process.env.NODE_ENV == 'development' && Config.PresentType) {
    axios.defaults.baseURL = '/api';
} else {
    axios.defaults.baseURL = localStorage.getItem('HospitalUrl');
} //localStorage.getItem('HospitalUrl');

// 请求超时时间
//axios.defaults.timeout = 10000;
//post请求
export function post(url, params, timeout) {
    if (!PresentType) { //苹果端
        return XMLHttpRequest(url, params, timeout, 'post')
    }
    axios.defaults.timeout = !!timeout ? timeout : 10000
    return new Promise((resolve, reject) => {
        axios.post(url, params, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
            .then(response => {
                resolve(response.data);
            }).catch((err) => {
                Toast("网络开小差啦,请稍后再试!", 2000);
                reject(err.data)
            })
    })
}

//get请求
export function get(url, params, timeout) {
    if (!PresentType) { //苹果端
        return XMLHttpRequest(url, params, timeout, 'get')
    }
    axios.defaults.timeout = !!timeout ? timeout : 10000
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            }
        }).then(res => {
            resolve(res.data);
        }).catch((err) => {
            Toast("网络开小差啦,请稍后再试!", 2000);
            reject(err)
        })
    })
}


//适用于IOS端请求    由于IOS新版操作系统认定本地请求外网属于跨域行为  故不能使用基于httprequest的axios（ajax）
//Mui基于 new plus.net.httprequest可解决跨域问题
function XMLHttpRequest(url, data, timeout, type) {
    return new Promise((resolve, reject) => {
        Mui.ajax(`${axios.defaults.baseURL}/${url}`, {
            data: data,
            dataType: 'json',
            type: type,
            timeout: timeout ? timeout : 100000,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': type == 'get' ? '' : 'application/json;charset=UTF-8'
            },
            beforeSend: function() {
                Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: '正在加载!'
                });
            },
            processData: true,
            success: function(data) {
                Toast.clear();
                resolve(data);
            },
            error: function(xhr, type, errorThrown) {
                if (xhr.status == 401) { //无权限或Token到期 -返回登录页
                    reject('当前请求过期');
                    Toast({
                        message: '登陆已过期，请重新登陆!',
                        duration: 2000,
                        onClose: () => {
                            localStorage.removeItem('userInfo');
                            localStorage.removeItem('token');
                            router.replace({
                                name: 'Login'
                            });
                        }
                    });
                    return;
                }
                Toast.clear();
                Toast("网络开小差啦,请稍后再试!", 2000);
                reject('当前请求异常');
            }
        })
    })
}

//请求前的操作
axios.interceptors.request.use(function(config) {
    Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '正在加载!'
    });
    return config;
})

//响应后的操作
axios.interceptors.response.use(function(config) {
    Toast.clear();
    return config;
},function(error){
    if(error.response.status==401){
        Toast({
            message: '登陆已过期，请重新登陆!',
            duration: 2000,
            onClose: () => {
                localStorage.removeItem('userInfo');
                localStorage.removeItem('token');
                router.replace({
                    name: 'Login'
                });
            }
        });
    }
    return error;
})



//////////////////
// WEBPACK FOOTER
// ./tool/http.js
// module id = null
// module chunks = 